<script setup lang="ts">
import useLocale from '../../../../composables/use-locale';
import { cellColor } from './cellColor';

defineProps<{
  players: number;
  questions: number;
}>();

const { t } = useLocale();

const swatches = [
  { color: cellColor.correct, label: 'correct' },
  { color: cellColor.wrong, label: 'incorrect' },
  { color: cellColor.none, label: 'no_answer' },
];
</script>

<template>
  <div class="d-flex flex-wrap align-center ga-4 px-3 py-2 bg-surface-container-low text-caption">
    <span v-for="swatch in swatches" :key="swatch.label" class="d-flex align-center ga-2 on-surface-medium">
      <v-sheet :color="swatch.color" width="14" height="14" rounded="sm" />
      {{ t(`results.answer_recap.${swatch.label}`) }}
    </span>

    <span class="ms-auto on-surface-low" data-testid="quizter-answer-recap-matrix-summary">
      {{ t('results.answer_recap.summary', { players, questions }) }}
    </span>
  </div>
</template>
